/**
 * Filter memory for Product Insights: which URL params are remembered on the
 * account and restored when the page is opened without them.
 *
 * /product-insights/lae (LAE Productivity, Schools mode) mirrors the LAE app,
 * which saves cycle / funnel / source / period per account. The keys are the
 * page's URL keys (`lae-params.ts`). An absent `cycle` means the CURRENT cycle
 * (`resolveDefaultCycle`), so leaving it absent is remembered as absent and
 * follows the current cycle; an explicit pick (`all` or a `YYYY-YY` label) is
 * remembered as picked.
 *
 * Keys deliberately LEFT OUT:
 * - `d` (a past day): in LAE a past day is a shared-link thing, not a place to live.
 * - `school`, `schoolFunnel`: the School modal is opened from a row or a link,
 *   never restored on arrival.
 *
 * Sort, column filters, the split switch, the trend metric, the legend and the
 * status pick are table / plain state (`useTableFilters`, `useRememberedState`),
 * not URL state, so they are not listed here.
 */
import type { FilterMemoryRule } from './types';

export const FILTER_MEMORY_PRODUCT_INSIGHTS: readonly FilterMemoryRule[] = [
  {
    path: '/product-insights/lae',
    keep: [
      'cycle', // filter: LAE cycle label or `all`; absent = current cycle
      'funnel', // filter: funnel; absent = all funnels
      'source', // filter: `system` | `manual`; absent = all calls
      'p', // period: day | 7d | 30d | 12w | custom; absent = 12w
      'from', // custom period start
      'to', // custom period end
    ],
  },
];
